export default __webpack_public_path__ + "static/media/AcuraFavicon.dfec820e.ico";